'use client';

import dynamic from 'next/dynamic';

// Dynamically import client components
const FloatingCompareButton = dynamic(() => import('@/components/cards/FloatingCompareButton'), {
  ssr: false,
});

const CompareCardButton = dynamic(() => import('@/components/cards/CompareCardButton'), {
  ssr: false,
});

interface CardCompareButtonProps {
  cardKey: string;
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'default' | 'sm' | 'lg';
  className?: string;
}

export function CardCompareButtonClient({
  cardKey,
  variant,
  size,
  className,
}: CardCompareButtonProps) {
  return (
    <CompareCardButton cardKey={cardKey} variant={variant} size={size} className={className} />
  );
}

export function FloatingCompareButtonClient() {
  return <FloatingCompareButton />;
}
